import type { IKeyholderDataWeb } from '@/app-package';
import axios from 'axios';

const getKeyholderBillingProfile = async ({
  orgId,
  billingCustomerNumber,
}: {
  orgId: string;
  billingCustomerNumber: string;
}): Promise<IKeyholderDataWeb | undefined> => {
  try {
    const { data } = await axios.get<IKeyholderDataWeb>(
      `/supra/billing_profile/${orgId}/${billingCustomerNumber}`,
    );
    return data;
  } catch (error: any) {
    return undefined;
  }
};

export default getKeyholderBillingProfile;
